<rx-intuitive-treatment-viewlist-item-base
	[isIndicationVisible]="true"
	[indicationId]="item.indicationId"
	[previewTitle]="item.previewTitle"
>
	<div class="rx-intuitive-tooth-treatment-viewlist-item__title" rxIntuitiveViewlistItemTitle>
		{{ bridgeSpanDisplay }}
	</div>
	<div rxIntuitiveViewlistItemPreview>
		<span class="rx-intuitive-tooth-treatment-viewlist-item__preview-line rx-intuitive-tooth-treatment-viewlist-item__preview-line--single">{{ item.previewLine }}</span>
	</div>
</rx-intuitive-treatment-viewlist-item-base>
